/**
 * 弹跳类型
 */
export enum BounceType {
  /** 顶部支持弹跳 */
  Up = 'up',
  /** 底部支持弹跳 */
  Down = 'down',
}
